import { defineComponent, h, useAttrs } from 'vue'
import { VNavigationDrawer } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

VNavigationDrawer.compatConfig = {
  ...(VNavigationDrawer.compatConfig || {}),
  ATTR_FALSE_VALUE: false,
  COMPONENT_V_MODEL: false
}

function normalizeBooleanProp(value) {
  if (value === false || value === 'false' || value == null) return undefined
  if (value === '' || value === true || value === 'true') return true
  return value
}

function normalizeModelValue(value) {
  if (value === false || value === 'false' || value == null) return false
  if (value === '' || value === true || value === 'true') return true
  return Boolean(value)
}

function normalizeWidth(value) {
  if (typeof value !== 'string' || !value.trim().endsWith('%')) return value
  if (typeof window === 'undefined') return value

  const percentage = Number(value.trim().replace('%', ''))
  if (!Number.isFinite(percentage)) return value

  return `${window.innerWidth * (percentage / 100)}px`
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }

  if (normalized.modelValue == null && attrs.value !== undefined) {
    normalized.modelValue = normalizeModelValue(attrs.value)
  } else if (normalized.modelValue !== undefined) {
    normalized.modelValue = normalizeModelValue(normalized.modelValue)
  }

  if (hasBooleanishAttr(attrs.right) && normalized.location == null) {
    normalized.location = 'end'
  }

  if (
    hasBooleanishAttr(attrs['hide-overlay']) ||
    hasBooleanishAttr(attrs.hideOverlay)
  ) {
    normalized.scrim = false
  }

  normalized.permanent = normalizeBooleanProp(normalized.permanent)
  normalized.temporary = normalizeBooleanProp(normalized.temporary)
  normalized.touchless = normalizeBooleanProp(normalized.touchless)
  normalized.width = normalizeWidth(normalized.width)
  normalized.style = [
    attrs.style,
    normalized.width ? { width: normalized.width } : null
  ]

  delete normalized.value
  delete normalized.right
  delete normalized.fixed
  delete normalized['hide-overlay']
  delete normalized.hideOverlay

  return normalized
}

export default defineComponent({
  name: 'VNavigationDrawerCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        VNavigationDrawer,
        {
          ...normalizeAttrs(attrs),
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          }
        },
        slots
      )
  }
})
